import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";
import Checkbox from "@mui/material/Checkbox";
import FormControl from "@mui/material/FormControl";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import InputLabel from "@mui/material/InputLabel";
import ListItemText from "@mui/material/ListItemText";
import ListSubheader from "@mui/material/ListSubheader";
import MenuItem from "@mui/material/MenuItem";
import OutlinedInput from "@mui/material/OutlinedInput";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import _ from "lodash";
import React from "react";

export function ShopSelection(props) {
  const {
    filter,
    shopOptions,
    handleShopFilterChange,
    disabled = false,
    selectedShop = [],
  } = props;
  const [searchText, setSearchText] = React.useState("");
  const handleShopChange = async (event) => {
    if (_.includes(event.target.value, "ALL")) {
      if (event.target.value.length - 1 === shopOptions.length) {
        handleShopFilterChange([]);
      } else {
        handleShopFilterChange(
          _.difference(
            _.map(shopOptions, (o) => o.shop_id),
            selectedShop
          )
        );
      }
    } else {
      handleShopFilterChange(event.target.value);
    }
  };
  function makeItems(data) {
    const groupByArea = _.groupBy(data, "area_name");
    const items = [];
    _.forEach(groupByArea, (values, area) => {
      items.push(
        <ListSubheader style={{ zIndex: 0 }} key={area}>
          <IconButton
            onClick={(event) => {
              let concatValue = [];
              const isExisting = data.find(
                (d) => d.area_name === area && filter.shop.includes(d.shop_id)
              );

              if (isExisting) {
                const currentValues = data.filter((options) =>
                  filter.shop.includes(options.shop_id)
                );
                concatValue = _.map(
                  _.filter(currentValues, (d) => d.area_name !== area),
                  "shop_id"
                );
              } else {
                const options = _.filter(
                  shopOptions,
                  (s) => s.area_name === area
                );

                concatValue = _.concat(filter.shop, _.map(options, "shop_id"));
              }

              handleShopFilterChange(_.difference(concatValue, selectedShop));
            }}
          >
            {area}
          </IconButton>
        </ListSubheader>
      );
      _.forEach(_.sortBy(values, "work_shortcode"), (value, index) => {
        const disabledOption = selectedShop.includes(value.shop_id);
        items.push(
          <MenuItem
            key={value.shop_id}
            value={value.shop_id}
            disabled={disabledOption || disabled}
          >
            <Checkbox
              disabled={disabledOption || disabled}
              checked={
                filter.shop.find((d) => d === value.shop_id) !== undefined
              }
            />
            {`${value.work_shortcode} - ${value.work_name} `}
          </MenuItem>
        );
      });
    });
    return items;
  }
  return (
    <FormControl fullWidth>
      <InputLabel id="shop-select-label">店鋪</InputLabel>
      <Select
        {...props}
        MenuProps={{ autoFocus: false }}
        labelId="shop-select-label"
        id="shop-select"
        value={filter.shop}
        label="店鋪"
        multiple
        fullWidth
        onChange={handleShopChange}
        renderValue={(selected) => {
          return selected.length === shopOptions.length
            ? "所有店鋪"
            : `已選擇${selected.length}間`;
        }}
        onClose={() => setSearchText("")}
        input={<OutlinedInput label="換領店鋪" />}
      >
        <ListSubheader
          style={{
            position: "sticky",
            top: 0,
            zIndex: 1,
          }}
        >
          <TextField
            sx={{ width: 600 }}
            style={{
              backgroundColor: "white",
            }}
            autoFocus
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton edge="end" onClick={() => setSearchText("")}>
                    <ClearIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            onKeyDown={(e) => {
              if (e.key !== "Escape") {
                // Prevents autoselecting item while typing (default Select behaviour)
                e.stopPropagation();
              }
            }}
          />
        </ListSubheader>
        <MenuItem
          key={"ALL"}
          value={"ALL"}
          style={{
            position: "sticky",
            top: 56,
            backgroundColor: "white",
            zIndex: 1,
          }}
          disabled={disabled}
        >
          <Checkbox
            disabled={disabled}
            checked={filter.shop.length === shopOptions.length}
          />
          <ListItemText primary={"所有店鋪"} />
        </MenuItem>
        {makeItems(
          _.filter(shopOptions, (s) => {
            return (
              s?.work_shortcode
                ?.toLowerCase()
                ?.indexOf(searchText.toLowerCase()) > -1 ||
              s?.work_name?.toLowerCase()?.indexOf(searchText.toLowerCase()) >
                -1
            );
          })
        )}
      </Select>
    </FormControl>
  );
}
